import { Box, Button, Chip, FormLabel, InputAdornment, InputLabel, Paper, SxProps, TextField, Theme, Typography } from "@mui/material";
import { LatLng } from "leaflet";
import React from "react";
import { AddressApiRef, AddressPanel } from "../../components/address/AddressPanel";
import { ILocation } from "../../components/address/common";
import { AbstractTypedDataForm } from "../../components/data/DataForm";
import { FormNumberInput, FormTextInput, TextInput } from "../../components/form/TextInput";
import { House, IHasAddress } from "../../models/Types";
import PeriodicServiceCombo from "../project/periodicService/PeriodicServiceCombo";
import { isSystemTenant } from "../../models/Tenant";
import InhabitantCombo from "../inhabitants/InhabitantCombo";
import { isMobile, moneyFormat } from "../../utils";
import NavLink from "../../components/NavLink";
import { houseStore } from "./HouseCombo";

export interface HouseDto extends House, IHasAddress {
}

export class HouseForm extends AbstractTypedDataForm<HouseDto, ILocation & { onlyRequired?: boolean }, {}> {
    private typedLocation?: any
    private addressRef?: AddressApiRef;
    private ki = 0;

    protected getTypeName(): React.ReactNode {
        return 'Локация';
    }

    componentWillReceiveProps(n: Readonly<{ id: number } & ILocation>, nextContext: any): void {
        super.componentWillReceiveProps(n, nextContext);
        const p = this.props;
        if (p.id == n.id && n.lat && n.lon && (p.lat != n.lat || p.lon != n.lon)) {
            this.addressRef?.setLatLon(new LatLng(n.lat, n.lon));
        }
    }

    clear(): void {
        this.addressRef?.clear();
        super.clear();
    }

    protected getFormStyle(): SxProps<Theme> | undefined {
        return {
            ...this.props.sx,
            overflow: 'auto',
            flexDirection: 'row',
            alignItems: 'flex-start'
        };
    }

    buildButtons() {
        return [];
    }

    protected getTypeId(): string {
        return 'House';
    }

    protected createEntity() {
        return new House() as HouseDto;
    }

    onSave() {
        houseStore.clear();
        return super.onSave();
    }

    onAfterDelete() {
        houseStore.clear();
        return super.onSave();
    }

    protected buildItems(entity?: HouseDto | undefined): React.ReactNode {
        const iss = isSystemTenant();
        const disabled = this.isReadOnly();

        return <>
            <Paper sx={isMobile() ? undefined : { minWidth: 500 }} elevation={this.props.onlyRequired ? 2 : undefined}>
                {entity?.Duty ? <NavLink route={[['page', 'bill'], ['id'], ['filter', 'HouseId=' + entity.Id]]} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <InputLabel component="span">Задолжность по начислениям: </InputLabel>
                    <Chip size="small" color="warning" label={moneyFormat(entity?.Duty)} />
                </NavLink> : null}
                <FormTextInput key={`street-${this.ki}`} required={true} label="Улица" name="Street" form={this} entity={entity} />

                <FormTextInput key={`number-${this.ki}`} required={true} label="Номер дома" name="Number" form={this} entity={entity} />

                {entity && <AddressPanel entity={entity} apiRef={x => this.addressRef = x}
                    disabled={disabled}
                    hideMap={disabled && isMobile()}
                    onAdressChange={s => {
                    if (s?.data && entity) {
                        var nu = false;
                        if (s.data.street !== entity.Street) {
                            entity.Street = s.data.street as string;
                            nu = true;
                        }
                        if (s.data.house !== entity.Number) {
                            entity.Number = s.data.house as string;
                            nu = true;
                        }
                        if (nu) {
                            this.ki++;
                            this.forceUpdate();
                        }
                    }
                }} />}

                <TextInput key="OwnerId"
                    value={entity?.OwnerId}
                    label="Владелец"
                    name="OwnerId"
                    onChange={this.onChange}
                    component={(onChange, error) => <InhabitantCombo
                        name="OwnerId"
                        error={!!error}
                        disabled={disabled}
                        value={entity?.OwnerId}
                        onChange={onChange} />} />

                {this.props.onlyRequired ? null : <>
                    {iss ? null : <>
                        <FormNumberInput key={`Area-${this.ki}`} label="Площадь домовладения" name="Area" form={this} entity={entity} inputProps={{
                            endAdornment: <InputAdornment position="end">кв.м.</InputAdornment>
                        }} />

                        <FormNumberInput key={`LandArea-${this.ki}`} label="Площадь участка" name="LandArea" form={this} entity={entity} inputProps={{
                            endAdornment: <InputAdornment position="end">кв.м.</InputAdornment>
                        }} />

                        <FormNumberInput key={`Residents-${this.ki}`} label="Количество жильцов" name="Residents" form={this} entity={entity} inputProps={{
                            endAdornment: <InputAdornment position="end">чел.</InputAdornment>
                        }} />
                    </>}

                    <TextInput
                        value={entity?.PeriodicServices || []}
                        label="Регулярные услуги"
                        name="PeriodicServices"
                        onChange={this.onChange}
                        component={(onChange, error) => <PeriodicServiceCombo
                            name="PeriodicServices"
                            multiple={true}
                            error={!!error}
                            value={entity?.PeriodicServices || []}
                            disabled={disabled}
                            onChange={onChange} />} />

                    <TextField label="Баланс" disabled={true} value={entity?.Balance} />
                </>}

                <Box sx={{ display: 'flex' }}>
                    {this.props.onClose ? <Button variant="outlined" onClick={() => this.props.onClose?.()}>Отмена</Button> : null}
                    {disabled ? null : <>
                        <div style={{ flex: 1 }} />
                        <Button variant="contained" type="submit" onClick={this.save}>Сохранить</Button>
                    </>}
                </Box>
            </Paper>
        </>;
    }
}